import { render, staticRenderFns } from "./GuestHero.vue?vue&type=template&id=d47f5e32&scoped=true&"
import script from "./GuestHero.vue?vue&type=script&lang=ts&"
export * from "./GuestHero.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d47f5e32",
  null
  
)

export default component.exports